import type { PostHogBootstrapData } from '../getPostHogBootstrapData';

import { datadog } from './datadog';
import { posthog } from './posthog';

export function initAnalyticsServices(postHogBootstrapData: PostHogBootstrapData | null) {
  try {
    posthog.init(postHogBootstrapData);
  } catch (error) {
    console.error('Failed to initialize posthog client', { error });
  }
  try {
    datadog.init();
  } catch (error) {
    console.error('Failed to initialize datadog client', { error });
  }
}

export { datadog, posthog };
